import axios from '@axios'

export default {
  loadTable(queryFilter) {
    let queryUrl = ''
    queryUrl = `?page=${queryFilter.page - 1}&size=${queryFilter.size}&sort=${
      queryFilter.sort
    },${queryFilter.order}`
    if (queryFilter.filter) {
      queryUrl = `/pesquisa?${queryFilter.filter}`
    }
    return axios.get(`/protocolo/protocolo_meios${queryUrl}`)
  },
  insert(data) {
    return axios.post('/protocolo/protocolo_meios', data)
  },
  edit(data) {
    return axios.put(`/protocolo/protocolo_meios/${data.id}`, data)
  },
  delete(id) {
    return axios.delete(`/protocolo/protocolo_meios/${id}`)
  }
}
